import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommChevronLeftIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.7657 6.32775C16.0781 6.02401 16.0781 5.53155 15.7657 5.22781C15.4533 4.92406 14.9467 4.92406 14.6343 5.22781L8.23431 11.45C7.9219 11.7538 7.9219 12.2462 8.23431 12.55L14.6343 18.7722C14.9467 19.0759 15.4533 19.0759 15.7657 18.7722C16.0781 18.4685 16.0781 17.976 15.7657 17.6723L9.93137 12L15.7657 6.32775Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
